import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ClasificacionRepository } from 'src/app/domain/service/clasificacion/clasificacion-repository';
import { Clasificacion, ClasificacionFiltro } from 'src/app/domain/model/clasificacion/clasificacion';

@Injectable({ providedIn: 'root' })
export class HttpClasificacionRepository extends ClasificacionRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/clasificaciones`;

  buscar(filtro: ClasificacionFiltro): Promise<Clasificacion[]> {
    let params = new HttpParams();
    if (filtro.codigo) params = params.set('codigo', filtro.codigo);
    if (filtro.descripcion) params = params.set('descripcion', filtro.descripcion);
    params = params.set('start', String(filtro.start ?? 0));
    params = params.set('length', String(filtro.length ?? 10));

    return firstValueFrom(this.http.get<Clasificacion[]>(this.baseUrl, { params }));
  }

  contar(filtro: ClasificacionFiltro): Promise<number> {
    let params = new HttpParams();
    if (filtro.codigo) params = params.set('codigo', filtro.codigo);
    if (filtro.descripcion) params = params.set('descripcion', filtro.descripcion);
    return firstValueFrom(this.http.get<number>(`${this.baseUrl}/count`, { params }));
  }
}
